import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { actions } from '../../../../context';
import { useEffect, useState } from 'react';
import SuccessConfirmationModal from '../../SuccessConfirmationModal';
import hasPermission from '../../../Shared/hasPermission';

const DaylightMappingCommentModal = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(
        (state) => state.daylight.isMappingCommentModalOpen
    );
    const selectedMapping = useSelector(
        (state) => state.daylight.actionTargetMapping,
        shallowEqual
    );
    const selectedCode = useSelector(
        (state) => state.daylight.actionTargetCode
    );
    const practiceId = useSelector((state) => state.daylight.practice?.id);
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canWriteComments = hasPermission(
        'CodeMapsCommentsWrite',
        permissions
    );

    const [isEditingComment, setIsEditingComment] = useState(
        (selectedMapping?.comments === '' ||
            selectedMapping?.comments === null) &&
            canWriteComments
    );
    const [commentText, setCommentText] = useState(selectedMapping?.comments);
    const [isSendingRequest, setIsSendingRequest] = useState(false);

    // state for confirmation modal
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
        useState(false);
    const [successResponse, setSuccessResponse] = useState();

    useEffect(() => {
        setIsEditingComment(
            (selectedMapping?.comments === '' ||
                selectedMapping?.comments === null) &&
                canWriteComments
        );
        setCommentText(selectedMapping?.comments);
    }, [selectedMapping]);

    const closeCommentHandler = () => {
        dispatch(actions.daylight.setActionTargetMapping(null));
        dispatch(actions.daylight.setActionTargetCode(null));
        dispatch(actions.daylight.setMappingCommentModalOpen(false));
        setCommentText('');
    };

    const cancelEditCommentHandler = () => {
        setIsEditingComment(false);
        setCommentText(selectedMapping?.comments);
    };

    const saveCommentHandler = () => {
        setIsSendingRequest(true);
        dispatch(
            actions.daylight.updateCodeMappingComments(
                practiceId,
                selectedCode,
                selectedMapping.id,
                commentText
            )
        );
        setIsEditingComment(false);
        closeCommentHandler();
        setIsSendingRequest(false);
    };

    const getEditCommentButton = () => {
        if (isEditingComment) {
            return (
                <Button
                    color="success"
                    onClick={() => saveCommentHandler()}
                    disabled={isSendingRequest}>
                    Save
                </Button>
            );
        } else {
            return (
                <Button
                    color="primary"
                    onClick={() => setIsEditingComment(!isEditingComment)}
                    hidden={!canWriteComments}>
                    Edit
                </Button>
            );
        }
    };

    const getCloseButton = () => {
        if (isEditingComment) {
            return (
                <Button
                    color="secondary"
                    onClick={() => cancelEditCommentHandler()}
                    disabled={isSendingRequest}>
                    Cancel
                </Button>
            );
        } else {
            return (
                <Button color="secondary" onClick={() => closeCommentHandler()}>
                    Close
                </Button>
            );
        }
    };

    return (
        <>
            <SuccessConfirmationModal
                isOpen={isConfirmationModalOpen}
                closeBehavior={() => setIsConfirmationModalOpen(false)}
                successResponse={successResponse}
            />
            <Modal isOpen={isOpen} className="text-light">
                <ModalHeader>Edit Comments</ModalHeader>
                <ModalBody>
                    <Input
                        type="textarea"
                        rows="8"
                        value={commentText}
                        disabled={!isEditingComment}
                        maxLength={800}
                        onChange={(e) => setCommentText(e.target.value)}
                    />
                </ModalBody>
                <ModalFooter>
                    {getEditCommentButton()}
                    {getCloseButton()}
                </ModalFooter>
            </Modal>
        </>
    );
};

export default DaylightMappingCommentModal;
